/**
 * @author Hiroki Moto
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import isNil from 'ramda/src/isNil';
import length from 'ramda/src/length';
import Accordion from '@components/@core/Accordion';
import Filter from '@components/@core/Filter';
import Input from '@components/@core/Input';
import EditDropdown from '@components/EditDropdown';
import { LibraryToDoHabitScheduleDetailMenu } from '~/services/config';
import { getSettings } from '~/services/util';
import HabitListItem from './HabitListItem';

const Detail = ({ authors, departments, competencies, categories, data, userRole, onSelect }) => {
    if (isNil(data)) return null;

    const author = data.data.author || [data.author_id] || [];
    const departmentIds = data.data.department || [];
    const competencyIds = data.data.competency || [];
    const categoryIds = data.data.category || [];
    const children = data?.children || data?.schedules;

    const daily = [],
        weekly = [],
        monthly = [];
    children?.map((item) => {
        const { schedule_interval } = item.data;
        if (schedule_interval === 'day') daily.push(item);
        if (schedule_interval === 'week') weekly.push(item);
        if (schedule_interval === 'month' || isNil(schedule_interval)) monthly.push(item);
    });

    return (
        <>
            <Filter back="all habit schedules" />
            <div className="lib-todo-habit-schedule">
                <div className="habit-schedule-detail">
                    <div className="d-flex jc-between py-2">
                        <p className="dsl-b22 bold">{data.name || data.data.name}</p>
                        <EditDropdown options={LibraryToDoHabitScheduleDetailMenu[userRole]} onChange={onSelect} />
                    </div>
                    <div className="">
                        <p className="dsl-m12 mb-2">Description</p>
                        <p className="dsl-b16 p-2">{data.data.description || data.description}</p>
                    </div>
                    <Accordion className="settings-habit-schedule" icon="fas fa-gear">
                        <Row className="mt-1">
                            <Col xs={12} sm={6} className="my-3">
                                <Input disabled className="input-field" title="Author" direction="vertical" value={getSettings(author, authors, 'N/A')} />
                            </Col>
                            <Col xs={12} sm={6} className="my-3">
                                <Input disabled className="input-field" title="Categories" direction="vertical" value={getSettings(categoryIds, categories, 'N/A')} />
                            </Col>
                            <Col xs={12} sm={6} className="my-3">
                                <Input disabled className="input-field" title="Competencies" direction="vertical" value={getSettings(competencyIds, competencies, 'N/A')} />
                            </Col>
                            <Col xs={12} sm={6} className="my-3">
                                <Input disabled className="input-field" title="Departments" direction="vertical" value={getSettings(departmentIds, departments, 'N/A')} />
                            </Col>
                        </Row>
                    </Accordion>
                </div>
                <div className="detail-list mt-3">
                    <p className="dsl-b22 bold pt-3">Habits Included</p>
                    <p className="dsl-b18 text-500">Daily Habits</p>
                    <div className={`mb-4 ${length(daily) > 0 ? 'border-bottom' : ''}`}>
                        {daily.map((habit) => (
                            <HabitListItem key={habit.id} name={habit.name} description={habit.data.description} assigned={habit.data.assigned || 0} />
                        ))}
                    </div>
                    <p className="dsl-b18 text-500">Weekly Habits</p>
                    <div className={`mb-4 ${length(weekly) > 0 ? 'border-bottom' : ''}`}>
                        {weekly.map((habit) => (
                            <HabitListItem key={habit.id} name={habit.name} description={habit.data.description} assigned={habit.data.assigned || 0} />
                        ))}
                    </div>
                    <p className="dsl-b18 text-500">Monthly Habits</p>
                    <div className={`mb-4 ${length(monthly) > 0 ? 'border-bottom' : ''}`}>
                        {monthly.map((habit) => (
                            <HabitListItem key={habit.id} name={habit.name} description={habit.data.description} assigned={habit.data.assigned || 0} />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

Detail.propTypes = {
    editable: PropTypes.bool,
    tags: PropTypes.array,
    data: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        data: PropTypes.any,
        author_id: PropTypes.number,
    }),
};

Detail.defaultProps = {
    editable: false,
    tags: [],
    data: {
        id: 0,
        name: '',
        data: {},
        author_id: 0,
    },
};

export default memo(Detail);
